<div class="modalBase w-100">
  <span class="btn_Close" (click)="closeModal()"><i class="fas fa-times-circle"></i></span>
  <div class="pt-4 pb-4 pr-5 pl-5">
    <div class="text-center mb-4">
      <span class="titulo">Generar Reporte</span>
    </div>

    <div class="mt-1 mb-1 pt-1 pb-1"></div>
    <form class="form-group" [formGroup]="reportForm" (submit)="onSubmit()">
      <div class="row">
        <div class="col-12">
          @if (errorMessage) {
            <ngb-alert class="mt-3" type="danger" (close)="errorMessage = ''">{{ errorMessage }}
            </ngb-alert>
          }
          @if (successMessage) {
            <ngb-alert class="mt-3" type="success" (close)="successMessage = ''">{{ successMessage
            }}</ngb-alert>
          }
        </div>
      </div>

      <ul class="nav nav-tabs">
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="activeReportTab === 'manual'"
            (click)="activeReportTab = 'manual'">Reportes</button>
        </li>
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="activeReportTab === 'schedule'"
            (click)="activeReportTab = 'schedule'">Programación</button>
        </li>
      </ul>

      @if (activeReportTab === 'manual') {
        <div class="mt-4">
          <div class="row">
            <div class="col-12">
              <span class="subTitulo">Seleccione un rango de fechas</span>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <div class="row selectBase">
                <div class="col-2 d-flex align-items-center">
                  <span class="labeltext">Desde</span>
                </div>
                <div class="col-4">
                  <div class="w-100">
                    <div class="calendar_box">
                      <input class="input_tx" placeholder="dd/mm/yyyy" name="dateStart" formControlName="dateStart"
                        ngbDatepicker #dateStart="ngbDatepicker" />
                      <button class="bt_cal calendar pr-2 pl-2" (click)="dateStart.toggle()" type="button">
                        <i class="far fa-calendar-alt"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-2 d-flex align-items-center">
                  <span class="labeltext">Hasta</span>
                </div>
                <div class="col-4">
                  <div class="w-100">
                    <div class="calendar_box">
                      <input class="input_tx" placeholder="dd/mm/yyyy" name="dateFinish" formControlName="dateFinish"
                        ngbDatepicker #dateFinish="ngbDatepicker" />
                      <button class="bt_cal calendar pr-2 pl-2" (click)="dateFinish.toggle()" type="button">
                        <i class="far fa-calendar-alt"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4 pt-4">
            <div class="col-12">
              <span class="subTitulo">Seleccione el tipo de flujo</span>
            </div>
            <div class="col-12 mt-3 d-flex border-bottom py-3">
              <div class="col-2 d-flex align-items-center">
                <input type="checkbox" (change)="toggleAllWorkflows($event, 'manual')" />
              </div>
              <div class="col-10 text-col d-flex align-items-center">
                Seleccionar todos
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <div class="row">
                @for (workflow of workflows; track workflow; let i = $index) {
                  <div class="col-6 d-flex border-bottom py-3">
                    <div class="col-2 d-flex align-items-center">
                      <input type="checkbox" [checked]="workflow.isChecked" [value]="workflow.id"
                        (change)="changeSelection($event, 'manual')" />
                    </div>
                    <div class="col-10 text-col d-flex align-items-center">
                      {{ workflow.name }}
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end mt-4 mb-2">
            <button type="button" class="btn btn-outline-primary bg-white rounded-pill text-dark px-4 font-weight-bold mr-2"
              [disabled]="generatingConsolidated" (click)="generateConsolidated()">
              @if (generatingConsolidated) {
                <span>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Generando...
                </span>
              }
              @if (!generatingConsolidated) {
                <span>Generar consolidado</span>
              }
            </button>
            <button type="submit" class="btn btn-outline-primary bg-white rounded-pill text-dark px-4 font-weight-bold">
              Generar
            </button>
          </div>
        </div>
      }

      @if (activeReportTab === 'schedule') {
        <div class="mt-4">
          <div class="row">
            <div class="col-12 mt-4">
              <span class="subTitulo">Seleccione los flujos de la programación</span>
            </div>
            <div class="col-12 mt-3 d-flex border-bottom py-3">
              <div class="col-2 d-flex align-items-center">
                <input type="checkbox" (change)="toggleAllWorkflows($event, 'schedule')" />
              </div>
              <div class="col-10 text-col d-flex align-items-center">
                Seleccionar todos
              </div>
            </div>
            <div class="col-12 mt-4">
              <div class="row">
                @for (workflow of workflows; track workflow; let i = $index) {
                  <div class="col-6 d-flex border-bottom py-3">
                    <div class="col-2 d-flex align-items-center">
                      <input type="checkbox" [checked]="workflow.isScheduleChecked" [value]="workflow.id"
                        (change)="changeSelection($event, 'schedule')" />
                    </div>
                    <div class="col-10 text-col d-flex align-items-center">
                      {{ workflow.name }}
                    </div>
                  </div>
                }
              </div>
            </div>

            <div class="col-6 mt-3">
              <label class="labeltext">Frecuencia</label>
              <select class="form-control" formControlName="scheduleFrequency">
                <option value="weekly">Semanal</option>
                <option value="monthly">Mensual</option>
              </select>
            </div>

            @if (reportForm.controls.scheduleFrequency.value === 'weekly') {
              <div class="col-6 mt-3">
                <label class="labeltext">Día de la semana</label>
                <select class="form-control" formControlName="scheduleWeekday">
                  <option value="monday">Lunes</option>
                  <option value="tuesday">Martes</option>
                  <option value="wednesday">Miércoles</option>
                  <option value="thursday">Jueves</option>
                  <option value="friday">Viernes</option>
                  <option value="saturday">Sábado</option>
                  <option value="sunday">Domingo</option>
                </select>
              </div>
            }

            @if (reportForm.controls.scheduleFrequency.value === 'monthly') {
              <div class="col-6 mt-3">
                <label class="labeltext">Día del mes</label>
                <select class="form-control" formControlName="scheduleMonthDay">
                  @for (day of monthDays; track day) {
                    <option [value]="day">{{ day }}</option>
                  }
                  <option value="last">Último día del mes</option>
                </select>
              </div>
            }

            <div class="col-6 mt-3">
              <label class="labeltext">Hora de envío</label>
              <select class="form-control" formControlName="scheduleTime">
                @for (time of availableScheduleTimeOptions; track time) {
                  <option [value]="time">{{ time }}</option>
                }
              </select>
              @if (availableScheduleTimeOptions.length === 0) {
                <small class="text-danger d-block mt-1">
                  Para hoy ya no hay horarios disponibles. Elige otro día o guarda la programación mañana.
                </small>
              }
            </div>

            <div class="col-6 mt-3">
              <label class="labeltext">Periodo de datos</label>
              <select class="form-control" formControlName="scheduleDateRange">
                <option value="all">Todos los registros</option>
                <option value="currentWeek">Semana actual</option>
                <option value="previousWeek">Semana anterior</option>
                <option value="currentMonth">Mes actual</option>
                <option value="previousMonth">Mes anterior</option>
              </select>
            </div>

            <div class="col-12 mt-3">
              <label class="labeltext">Usuarios destinatarios</label>
              <ng-select formControlName="scheduleRecipientUserIds" [items]="users" bindLabel="text" bindValue="id"
                [multiple]="true" placeholder="Seleccione usuarios" class="form-control px-0 py-0">
              </ng-select>
            </div>

            <div class="col-12 mt-3 d-flex justify-content-end">
              <button type="button" class="btn btn-outline-primary bg-white rounded-pill text-dark px-4 font-weight-bold"
                [disabled]="savingSchedule || availableScheduleTimeOptions.length === 0" (click)="saveConsolidatedSchedule()">
                @if (savingSchedule) {
                  <span>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Guardando...
                  </span>
                }
                @if (!savingSchedule) {
                  <span>Guardar programación</span>
                }
              </button>
            </div>
          </div>
        </div>
      }
    </form>
</div>
</div>